import { UICoupon } from "pages/vendor/Coupons/Coupons"
import React from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import CouponActionMenus from "./Components/CouponActionMenus"
import { useTranslation } from "react-i18next"

interface CouponCardProps {
  coupon: UICoupon
  deleteCouponHandler: (coupon: UICoupon) => void
  editCouponHandler: (coupon: UICoupon) => void
  viewDetailsHandler: (coupon: UICoupon) => void
  toogleActiveCoupon: (coupon: UICoupon) => void
  addOfferHandler: (coupon: UICoupon) => void
  addCompaign: (coupon: UICoupon) => void
  autoAssignToDelivery: (coupon: UICoupon) => void
}
const CouponCard: React.FC<CouponCardProps> = ({
  coupon,
  deleteCouponHandler,
  editCouponHandler,
  viewDetailsHandler,
  toogleActiveCoupon,
  addOfferHandler,
  addCompaign,
  autoAssignToDelivery,
}) => {
  const { t } = useTranslation()

  return (
    <Col xxl="3" xl="4" sm="6">
      <Card className="text-center shadow-md rounded-3">
        <CardBody className="p-3">
          <div className="d-flex mb-2 align-items-start justify-content-between">
            <div className="d-flex flex-column align-items-start gap-1">
              <div className="fw-bold medium text-capitalize">
                {t("coupons_couponSerial")} {coupon.id}
              </div>
            </div>
            <CouponActionMenus
              coupon={coupon}
              editCouponHandler={editCouponHandler}
              viewDetailsHandler={viewDetailsHandler}
              deleteCouponHandler={deleteCouponHandler}
              addOfferHandler={addOfferHandler}
              addCompaign={addCompaign}
              autoAssignToDelivery={autoAssignToDelivery}
            />
          </div>
          <div className="text-capitalize small d-flex justify-content-start">
            {t("coupons_customer")}: {coupon.customer}
          </div>

          <div className="d-flex mb-2 align-items-start justify-content-between">
            <div className="d-flex flex-column align-items-start gap-1">
              <div className="fw-semibold medium text-capitalize">
                {t("coupons_price")}: QAR  {coupon.price}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <div className="border p-2 w-50 me-2 text-start shadow-md rounded-3">
              <div className="text-muted small text-capitalize">
                {t("coupons_product")}
              </div>
              <div className="text-muted">{coupon.count}</div>
            </div>
            <div className="border p-2 w-50 ms-2 text-start shadow-md rounded-3">
              <div className="text-muted small text-capitalize">
                {t("coupons_productSize")}
              </div>
              <span className="text-muted">{coupon.productSize}</span>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <div className="border p-2 w-50 me-2 text-start shadow-md rounded-3">
              <div className="text-muted small text-capitalize">
                {t("coupons_refillTimes")}
              </div>
              <div className="text-muted">{coupon.refillTimes}</div>
            </div>
            <div className="border p-2 w-50 ms-2 text-start shadow-md rounded-3">
              <div className="text-muted small">
                {t("coupons_itemRefilOnce")}
              </div>
              <span className="text-muted">{coupon.itemPerRefill}</span>
            </div>
          </div>
          <div className="d-flex justify-content-start">
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className={`form-check-input ${coupon.status === "Pending Approval" && "bg-warning border-warning"}`}
                id={`customSwitch${coupon.id}`}
                checked={coupon.status === "Active" || coupon.status === "Pending Approval"}
                onClick={() => toogleActiveCoupon(coupon)}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${coupon.id}`}
              >
                {coupon.status}
              </label>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

interface CouponsGrid {
  coupons: UICoupon[]
  deleteCouponHandler: (coupon: UICoupon) => void
  editCouponHandler: (coupon: UICoupon) => void
  viewDetailsHandler: (coupon: UICoupon) => void
  toogleActiveCoupon: (coupon: UICoupon) => void
  addOfferHandler: (coupon: UICoupon) => void
  addCompaign: (coupon: UICoupon) => void
  autoAssignToDelivery: (coupon: UICoupon) => void
}

export const CouponsGrid: React.FC<CouponsGrid> = ({
  coupons,
  deleteCouponHandler,
  editCouponHandler,
  viewDetailsHandler,
  toogleActiveCoupon,
  addOfferHandler,
  addCompaign,
  autoAssignToDelivery,
}) => {
  return (
    <Row>
      {coupons.map(coupon => (
        <CouponCard
          key={coupon.id}
          coupon={coupon}
          deleteCouponHandler={deleteCouponHandler}
          editCouponHandler={editCouponHandler}
          viewDetailsHandler={viewDetailsHandler}
          toogleActiveCoupon={toogleActiveCoupon}
          addOfferHandler={addOfferHandler}
          addCompaign={addCompaign}
          autoAssignToDelivery={autoAssignToDelivery}
        />
      ))}
    </Row>
  )
}
